import { configureStore } from "@reduxjs/toolkit";
import employeesReducer from "../features/employeesSlice";
import legalEmployeesReducer from "../features/legalEmployeesSlice";
import branchesReducer from "../features/branchesSlice";
import authorizationReducer from "../features/authorizationSlice";
import authorizationMobileReducer from "../features/authorizationMobileSlice";
import responseReducer from "../features/responseSlice";
import billsPageReducer from "../features/billsPageSlice";
import transactionDetails from "../features/transactionDetailsSlice";
import advancePayrollConfirmPopup from "../features/AdvancePayrollConfirmPopupSlice";
import quickPaySalary from "../features/QuickPaySlice";
import statementOfAccountReducer from "../features/statementOfAccountSlice";
import accountBalanceReducer from "../features/accountBalanceSlice";
import cfcLoanSlice from "../features/cfcLoanSlice";
import ExternalCashDepositReducer from "../features/ExternalCashDepositSlice";
import webSocketSlice from "../features/webSocketSlice";
import paymentRequestSlice from "../features/paymentRequestSlice";
import bobCorporateReducer from "../features/BOBCorporateSlice";
import bobTransactionDetails from "../features/BOBTransactionDetailsSlice";
import appMobileSlice from "../features/appMobileSlice";
import transferAbroadDetails from "../features/transferAbroadDetailsSlice";
import transferCountrySelection from "../features/TransferCountrySelectionSlice";
import bankAccountDetails from "../features/bankAccountDetailsSlice";
import legalEnrollment from "../features/legalEnrollmentSlice";
import BSLAccountSlice from "../features/BSLAccountSlice";
import cashInAndOutReducer  from "../features/CashInAndOutSlice";
import ButlerReducer  from "../features/CashInAndOutSlice";


const store = configureStore({
  reducer: {
    employees: employeesReducer,
    legalEmployees: legalEmployeesReducer,
    branches: branchesReducer,
    authorization: authorizationReducer,
    authorizationMobile: authorizationMobileReducer,
    transferResponse: responseReducer,
    billsPage: billsPageReducer,
    transactionDetails: transactionDetails,
    transferAbroadDetails: transferAbroadDetails,
    advancePayrollConfirm: advancePayrollConfirmPopup,
    quickPay: quickPaySalary,
    statementOfAccount: statementOfAccountReducer,
    accountBalance: accountBalanceReducer,
    cfcLoan: cfcLoanSlice,
    externalCash: ExternalCashDepositReducer,
    websocket: webSocketSlice,
    paymentRequest: paymentRequestSlice,
    bobCorporate: bobCorporateReducer,
    bobtransactionDetails: bobTransactionDetails,
    appData: appMobileSlice,
    transferCountrySelection: transferCountrySelection,
    bankAccountDetails: bankAccountDetails,
    legalEnrollment: legalEnrollment,
    bSLAccountSlice: BSLAccountSlice,
    cashInAndOut: cashInAndOutReducer ,
    ButlerSlice:ButlerReducer,
  },
});

export default store;
